import { getInputProps, Still } from 'remotion'
import { compositions, type PureProps } from './config'
import { PureCard } from './Card/PureCard'
import { data1 } from './data'
import './font.css'

const { title, preface, subtitle, poem, config, location, date, translators } = data1

const poemProps: PureProps = data1

const inputProps = getInputProps()
console.log('======', inputProps)

const settings = {
  pure: compositions.pure(config),
}
poemProps.config = { ...settings.pure, ...poemProps.config }

const pureSize = settings.pure.estimateRenderRect({
  lines: poem.split(/\n/),
  title,
  prefaceLines: preface?.split(/\n/) ?? [],
  subtitle: subtitle ?? '',
  settings: settings.pure,
  // Avoid "undefined undefined" inflating size when optional fields are absent
  location,
  date,
  translators,
})

export const Root: React.FC = () => {

  // Measurement mode: Render just the card so serverUrl can measure #measure-target
  const search = typeof window === 'undefined' ? new URLSearchParams() : new URLSearchParams(window.location.search)
  const hashParams = typeof window === 'undefined' ? new URLSearchParams() : new URLSearchParams((window.location.hash || '').replace(/^#\/?/, ''))
  const isMeasure = search.get('measure') === '1' || hashParams.get('measure') === '1'

  console.log('isMeasure:', isMeasure)
  if (isMeasure) {
    let props: PureProps = poemProps
    const injected = () => (window as unknown as { __MEASURE_PROPS__?: unknown }).__MEASURE_PROPS__
    const b64 = search.get('propsb64') || hashParams.get('propsb64')
    const tryDecode = (encoded: string): unknown | null => {
      try {
        let normalized = encoded.replace(/-/g, '+').replace(/_/g, '/')
        const padNeeded = (4 - (normalized.length % 4)) % 4
        if (padNeeded) normalized += '='.repeat(padNeeded)
        const bin = atob(normalized)
        const bytes = Uint8Array.from(bin, (c) => c.charCodeAt(0))
        const json = new TextDecoder('utf-8').decode(bytes)
        return JSON.parse(json)
      } catch {
        return null
      }
    }

    const ls = typeof window === 'undefined' ? null : localStorage.getItem('poemwiki-measure-props')
    const fromInjected = typeof window === 'undefined' ? null : injected()
    let fromLocal: unknown | null = null
    if (ls) {
      try {
        fromLocal = JSON.parse(ls)
      } catch {
        fromLocal = null
      }
    }
    const fromB64 = b64 ? tryDecode(b64) : null
    const fromInputProps = getInputProps() as unknown as Partial<PureProps>
    props = { ...poemProps, ...(fromInjected as Partial<PureProps> ?? {}), ...(fromLocal as Partial<PureProps> ?? {}), ...(fromB64 as Partial<PureProps> ?? {}), ...fromInputProps } as PureProps
    console.log('Measurement props resolved:', props)

    const conf = compositions.pure({ wrap: props.config?.wrap, scale: props.config?.scale, noAuthorLabel: props.config?.noAuthorLabel })
    props.config = { ...conf, ...props.config }

    return (
      <div id="measure-root" style={{ background: 'white' }}>
        <div id="measure-target" style={{ overflow: 'hidden' }}>
          <PureCard {...props} />
        </div>
      </div>
    )
  }

  return (
    <div style={{ background: 'white' }}>
      <Still
        component={PureCard as unknown as React.FC<Record<string, unknown>>}
        width={settings.pure.maxWidth}
        height={pureSize.height}
        id="pure"
        defaultProps={poemProps}
      />
    </div>
  )
}
